<div class="invite-card" #card>
  <div class="invite-eyebrow">{{ eyebrow }}</div>
  <div class="invite-name">{{ eventName }}</div>
  <div class="invite-when" *ngIf="whenLabel">{{ whenLabel }}</div>

  <div class="invite-qr">
    <img *ngIf="qr" [src]="qr" alt="QR code for this event" />
    <div class="invite-qr-loading" *ngIf="!qr && loading">Preparing your code…</div>
  </div>

  <div class="invite-scan">{{ scanLine }}</div>
  <div class="invite-fine">No app. No account. Just your camera.</div>
  <div class="invite-mark">picaggo</div>
</div>
